import React, { useEffect, useContext, useState } from 'react';
import { Link ,useNavigate } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';
import axios from 'axios';
import {cleanStr,cleanPass} from '../../comfunc';
import {strEncode,strDecode} from '../../encrpt';
import DataTable from 'react-data-table-component';
import DatePicker from "react-datepicker"; // Ensure you install react-datepicker
import '../Raportee/datatable.css';
import {API_BASE_URL} from "../../apiConfig.jsx";


function ResultReports() {
	const navigate = useNavigate();
	useEffect(() => {
		const authToken = localStorage.getItem("authToken");

		if (!authToken) {
			localStorage.removeItem("user"); // Clear user data
			navigate(""); // Ensure correct redirection path
		}
	}, [navigate]);

	const [data, setData] = useState([]);
	const [composant_data, setComposantData] = useState([]);
	const [error, setError] = useState(null);
	const [subcompname, setModalheading] = useState(null);
	const [indiid, setModalId] = useState(null);	
	const [modalData, setModalData] = useState([]);
	const [formData, setFormData] = useState(modalData.map(row => ({ ...row, dateValue: row.date || null })));
	const [headerscols, setHeaders] = useState([]);
	const [mergedData, setMergedData] = useState({});
	const [expandedData, setExpandedData] = useState({});
	const [openPDO, setOpenPDO] = useState(null);
	const [openComponent, setOpenComponent] = useState(null);
  
	// Toggle PDO-level visibility
	const togglePDO = (pdoName) => {
	  setOpenPDO(openPDO === pdoName ? null : pdoName);
	  setOpenComponent(null); // Reset component selection when switching PDO
	};
  
	// Toggle Component-level visibility
	const toggleComponent = (componentName) => {
	  setOpenComponent(openComponent === componentName ? null : componentName);
	};
     const maxLength = headerscols.length;
	 const filteredHeaders = headerscols.slice(0, maxLength - 1);
	 const headerRows = [
		{ ...filteredHeaders, isHeader: true }
	  ];
	  
	   //console.log("headerrows",filteredHeaders)
	  // Function to calculate colSpan dynamically
	 const calculateColSpan = () => {
			return Object.values(filteredHeaders[0]).filter(val => val !== null && val !== "").length;
		};

	 const customStyles = {
		headCells: {
		  style: {
			color:"white",
			background:"black",
			whiteSpace: "normal",
			wordBreak: "break-word",
			overflowWrap: "break-word",
			textAlign: "center",
			wrap :true
		  },
		}
	  }; 
	
	  const formattedColumns = Object.keys(formData[0] || {}).map((col) => {
		// Determine header display name from headerscols or fallback to cleaned name
		const displayName = col.includes("col_") ? headerscols[maxLength - 1]?.[col] || col : col.replace(/_/g, " ");
	  
		return {
		  name: displayName,
		  selector: row => row[col],
		  sortable: true,
		  cell: (row, index) => {
			if (displayName.includes("Date")) {
			  return (
				<DatePicker
				  selected={row[col] && !isNaN(Date.parse(row[col])) ? new Date(row[col]) : new Date()}
				  onChange={(date, event) => handleInputChange(index, col, date, event, row,displayName)}
				  dateFormat="yyyy-MM-dd"
				  className="input-box"
				  placeholderText="Select Date"
				/>
			  );
			} else if (displayName.includes("Commentaires")) {
				return (
				  <textarea					
					value={row[col] || ""}
					onChange={(e) => handleInputChange(index, col, e.target.value, e, row,displayName)}
			 		className="input-box"
				  />
				);
			  } else  {
			  return (
				<input
				  type="text"
				  value={row[col] || ""}
				  onChange={(e) => handleInputChange(index, col, e.target.value, e, row,displayName)}
				  className="input-box"
				/>
			  );
			}
			/* else {
			  // Ensure row[col] exists and is a valid string before applying regex
			  const spanRegex = /<span[^>]*>(.*?)<\/span>/i;
			  const cellValue = row[col] ? row[col].toString() : ""; // Convert to string to avoid errors
			  const match = cellValue.match(spanRegex);
			  return match ? <div dangerouslySetInnerHTML={{ __html: cellValue }} /> : cellValue;
			} */
		  },
		  subHeader: headerscols[maxLength - 2]?.[col] || "", // Fetch sub-header from the previous row dynamically
		};
	  });
 
	const formatted_Columns = formattedColumns.slice(1); // Removes the first column
	// Create DataTable with sub-headers properly displayed
const dataTableColumns = formatted_Columns.map((col) => ({
	...col,
	name: (
	  <div>
		<div style={{background:"green"}}><strong>{col.subHeader}</strong></div>
		<div>{col.name}</div>
	  </div>
	)
  }));
		  
	 useEffect(() => {
		axios.post(`${API_BASE_URL}/api/getresultcomponent`, { t: strEncode('pmis_result_component_master')},{ headers: { 'Content-Type': 'application/json' } }) 
          .then( (res) => {
            //console.log("res",res.data)
            setData(res.data);
          }).catch( (error) => { console.log(error); });
        
    }, []);
   
	useEffect(() => {
		if (modalData.length > 0) { // Ensure modalData contains valid entries
			setFormData(modalData.filter(row => Object.values(row).some(value => value !== "" && value !== null && value !== undefined)));
		}
	}, [modalData]);

	useEffect(() => {
		if (modalData.length > 0) { 
			// Ensure modalData contains valid entries by merging all objects
			const mergedFormData = modalData.flatMap(obj => obj); // Flatten nested arrays if needed	
			setFormData(mergedFormData.filter(row => 
				Object.values(row).some(value => value !== "" && value !== null && value !== undefined)
			));
		}
	}, [modalData]);

	const handleModalOpen = (id,subcomname) => {
		//alert(id);
		axios.post(`${API_BASE_URL}/api/getresultcomponentdata`, { t: strEncode('pmis_result_indicator_master'),indicatorid : strEncode(id)},{ headers: { 'Content-Type': 'application/json' } }) 
          .then( (res) => {
            //console.log("subcomponent",res.data)
			axios.post(`${API_BASE_URL}/api/custom/selectall`, { t: strEncode('pmis_result_master_planning_cols'),whrc : strEncode("component_id = "+id+"")},{ headers: { 'Content-Type': 'application/json' } }) 
          .then( (colsval) => {	  
			//console.log("colsval",colsval.data)
		const mergedModalData = [...colsval.data, ...res.data];
		setMergedData(mergedModalData);
        setHeaders(colsval.data); // Set headers separately if needed
        setModalData(res.data); // Store merged header + modal data
        setModalheading(subcomname);
		setModalId(id);
		})
          }).catch( (error) => { console.log(error); });
	};

	  // Handle input changes
	 /* const handleInputChange = (index, field, value) => {
		setFormData(prevData => {
			const updatedData = [...prevData];
			updatedData[index][field] = value instanceof Date ? value.toISOString().slice(0, 10) : value; // Convert date properly
			return updatedData;
		});
	}; 
   
	const handleInputChange = async (index, field, value, event, row,displayName) => {
		//console.log(field)
		try {
			// Extract indicator_id dynamically from the row
			const indicatorId = row?.indicator_id; 
	
			if (!indicatorId) {
				console.error("Indicateur_id manquant pour la ligne:", row);
				return;
			}
	
			 // **Skip validation if the field is a date**
			if (value instanceof Date) {
				setFormData(prevData => {
					const updatedData = [...prevData];
					updatedData[index][field] = value.toISOString().slice(0, 10);
					return updatedData;
				});
				return; // Exit function early
			}
			
			// Fetch stored values from another table
			const response = await axios.post(`${API_BASE_URL}/api/checkValue`, {
				t: strEncode('data_collection_realization'),
				field: strEncode(field),
				indicator_id: strEncode(indicatorId) // Use dynamic indicator_id
			}, { headers: { 'Content-Type': 'application/json' } });
	
			const storedSum = parseInt(response.data[0]?.sum ?? 0, 10);
			const storedMax = parseInt(response.data[0]?.maxval ?? 0, 10);
			const leftValue = Math.max(storedMax - storedSum, 0); // Ensure non-negative
	
			console.log("Retrieved:", { storedSum, storedMax, leftValue, inputValue: value });
	
	
			// **Allow entry up to `leftValue`**
			if (parseInt(value, 10) > leftValue) {
				alert(`Valeur saisie (${value}) dépasse la limite autorisée	(${leftValue}).`);
	
				if (event?.target) {
					//event.target.value = leftValue; // Set input value to max allowed
					event.target.setAttribute("placeholder", `Max: ${leftValue}`);
				}
	
				//return; // Prevent further execution
			}
	
			// Update the state if the value is valid
			setFormData(prevData => {
				const updatedData = [...prevData];
				updatedData[index][field] = value;
				return updatedData;
			});
	
			// Dynamically set max attribute for input field
			if (event?.target) {
				//event.target.setAttribute("max", leftValue);
				event.target.setAttribute("placeholder", `Max : ${leftValue}`);
			}
	
		} catch (error) {
			console.error("Erreur lors de la récupération de la valeur stockée", error);
		}
	}; */

	const handleInputChange = async (index, field, value, event, row, displayName) => {
		try {
			// Extract indicator_id dynamically from the row
			const indicatorId = row?.indicator_id; 
	
			if (!indicatorId) {
				console.error("Indicateur_id manquant pour la ligne:", row);
				return;
			}
	
			// **Skip validation if the field is a date**
			if (value instanceof Date) {
				setFormData(prevData => {
					const updatedData = [...prevData];
					updatedData[index][field] = value.toISOString().slice(0, 10);
					return updatedData;
				});
				return; // Exit function early
			}
	
			
			// **Update the state if the value is valid**
			setFormData(prevData => {
				const updatedData = [...prevData];
				updatedData[index][field] = value;
				return updatedData;
			});
	
		} catch (error) {
			console.error("Erreur lors de la récupération de la valeur stockée", error);
		}
	};
    
    // Submit data to backend
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
			console.log("formData",formData)
            const response = await axios.post(`${API_BASE_URL}/api/resultproject/realization/entry`, { data: formData });
            alert("Data saved successfully!");
        } catch (error) {
            console.error("Error saving data:", error);
        }
    };

    const closeModal = () => {
		setFormData([]);
	   }

	return (
		<div>
			<ol className="breadcrumb float-xl-end">
				<li className="breadcrumb-item"><Link to="/dashboard/v1">Home</Link></li>
				<li className="breadcrumb-item"><Link to="/dashboard/blank">Raportee</Link></li>
				<li className="breadcrumb-item active">Présentation du niveau d’atteinte des résultats du Projet</li>
			</ol>
			<h1 className="page-header">Présentation du niveau d’atteinte des résultats du Projet</h1>
			<Panel>
				<PanelHeader>Présentation du niveau d’atteinte des résultats du Projet</PanelHeader>
				<PanelBody>
				 <ul className="nav nav-pills mb-2">
					{data.map((item) => (
						<li className="nav-item" key={item.pdo} style={{width:"100%"}}>
						<a
							href="#"
							className={`nav-link ${openPDO === item.pdo ? "active" : ""}`}
							onClick={(e) => {
								e.preventDefault(); // Prevent React Router from interfering
								togglePDO(item.pdo);
							}}
							>
							{item.pdo}
							</a>

						{/* Tab Content Directly Below */}
						{openPDO === item.pdo && (
							<div className="tab-content p-3 rounded-top panel rounded-0 m-0">
							{item.component.map((comp) => (
								<div key={comp.component}>
								<ul className="nav nav-pills mb-2">
									<li className="nav-item" style={{width:"100%"}}>
									<a
											href="#"
											className={`nav-link ${openComponent === comp.component ? "active" : ""}`}
											data-bs-toggle="modal"
											data-bs-target="#modalPosBooking"											
											onClick={() => handleModalOpen(comp.id, comp.component)}
											>
										{comp.component}
										
									</a>
									</li>
								</ul>
								</div>
							))}
							</div>
						)}
						</li>
					))}
                 </ul>
				</PanelBody>
			</Panel>
			<div className="modal modal-pos fade" id="modalPosBooking">
				<div className="modal-dialog modal-lg" style={{maxWidth:"95%"}}>
					<div className="modal-content border-0">
						<div>
							<div className="p-0">
							<form onSubmit={handleSubmit}>								
								<div className="modal-body">
									<div className="d-flex align-items-center mb-3">
										<h4 className="modal-title d-flex align-items-center"><i className="fa fa-bowl-rice fs-2 me-2 my-n1"></i> {subcompname}</h4>
										<a href="/#" data-bs-dismiss="modal" onClick={closeModal} className="ms-auto btn-close">&nbsp;</a>
									</div>
									<div className="row">
									<div className="table-responsive">
								<DataTable 
									 columns={dataTableColumns} 
									 data={formData} 
									 pagination 						 
									 className="datatable-header"
									 customStyles={customStyles}
									 conditionalRowStyles={[
										{
										  when: row => row.isHeader, // Detect header rows
										  style: { backgroundColor: "#f4f4f4", fontWeight: "bold", textAlign: "center" },
										},
									  ]}></DataTable>


													
							</div>
									</div>
								</div>
								<div className="modal-footer">									
									<button type="submit" className="btn btn-success w-100px">Save</button>
								</div>
								</form>


							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default ResultReports;